module.exports = __webpack_public_path__ + "static/media/3 1 tattoo arm sleeve warrior sword tiger intense dark realism.1280x2276.dac70d27.webp";